import { securedFetch } from "../auth/authService";
import { LICENSE_API } from "../vars";
import store from "../app/store";
import { createAction } from "@reduxjs/toolkit";
import { ACTION_LICENSE_LOADED, ACTION_MACHINE_DATA_LOADED } from "./LicensePageReducer";

export async function loadLicense() {
    try {
        const response = await securedFetch(LICENSE_API);
        if (response.ok) {
            const jsonResponse = await response.json();
            store.dispatch(createAction(ACTION_LICENSE_LOADED)({ license: jsonResponse }));
            return jsonResponse;
        }
        return null;
    } catch (error) {
        console.error("Error loading license:", error);
        return null;
    }
}

export async function getAllowedDevicesCount() {
    try {
        const response = await securedFetch(LICENSE_API);
        if (response.ok) {
            const jsonResponse = await response.json();
            return jsonResponse.maxDevices;
        }
        return 0;
    } catch (error) {
        console.error("Error getting allowed devices count:", error);
        return 0;
    }
}

export async function loadMachineData() {
    try {
        const response = await securedFetch(`${LICENSE_API}/machine`);
        if (response.ok) {
            const jsonResponse = await response.json();
            store.dispatch(createAction(ACTION_MACHINE_DATA_LOADED)({ machineData: jsonResponse }));
            return jsonResponse;
        }
        return null;
    } catch (error) {
        console.error("Error loading machine data:", error);
        return null;
    }
}

export async function uploadLicense(license) {
    try {
        const response = await fetch(LICENSE_API, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ license })
        });
        return response;
    } catch (error) {
        console.error("Error uploading license:", error);
        return null;
    }
}
